import { ApiService } from "./ApiService"

export class TransactionService {

    static uri = '/transaction';

    static get({ params = {} }) {
        // Filter parameter kosong agar tidak terkirim sebagai string kosong di URL
        const cleanedParams = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== "" && value !== null && value !== undefined)
        );
    
        return ApiService.get(`${this.uri}`, {
            params: cleanedParams,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static show({id}) {
        return ApiService.get(`${this.uri}/show/${id}`);
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static profileUpdate({ data, id }) {
        return ApiService.post(`${this.uri}/profile-update/${id}`, data);
    }

    static locationUpdate({ id, data }) {
        return ApiService.post(`${this.uri}/location-update/${id}`, data);
    }

    static statusUpdate({ id, data }) {
        return ApiService.post(`${this.uri}/update-status/${id}`, data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}